class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '#mobile-menu',
			openMenuButton: '#open-menu',
			closeMenuButton: '#close-menu',
			menuGroup: '.mobile-menu-item.has-children > .item-title',
			menuBack: '.mobile-menu-item.menu-back > .back-button',
		}, config);

		this.$scope = $(this.config.scope);

		this.init();
	}

	init() {
		this.setHeight();
		this.addEventListeners();

	}

	addEventListeners() {
		$(this.config.openMenuButton).on('click', this.openMenu.bind(this));
		$(this.config.closeMenuButton).on('click', this.closeMenu.bind(this));
		this.$scope.on('click', this.config.menuGroup, this.openSubMenu.bind(this));
		this.$scope.on('click', this.config.menuBack, this.closeSubMenu.bind(this));
		$(window).resize(this.setHeight.bind(this));
	}

	openMenu(e) {
		e.preventDefault();
		let $menu = this.$scope;
		$menu.toggleClass('open');
		$('body').toggleClass('no-scrolling');
	}

	closeMenu(e) {
		e.preventDefault();
		let $menu = this.$scope;
		$menu.removeClass('open');
		$('body').removeClass('no-scrolling');
		$menu.find('.children').removeClass('open');
	}

	openSubMenu(e) {
		e.preventDefault();
		$(e.currentTarget).closest('.mobile-menu-item').find('> .children').addClass('open');
		$('body').addClass('no-scrolling');
	}

	closeSubMenu(e) {
		e.preventDefault();
		$(e.currentTarget).closest('.children').removeClass('open');
		$('body').removeClass('no-scrolling');
	}

	setHeight() {
		this.$scope.height(window.innerHeight);
		this.$scope.find('.children').height(window.innerHeight - 140 - 80); //140px & 80px from .menu-inner
	}
}

export default Header;
